import { FooterProps } from './types';
import FooterColumn from './FooterColumn';
import FooterColumnSocial from './FooterColumnSocial';
import KeyLine from 'components/shared/KeyLine';
import { liveUpdateAttrs } from 'libs/contentful/utils';

const SiteFooter = ({
  sys,
  footerColumns,
  showSocialLinkColumn,
  showFooterKeyline,
}: FooterProps & { showFooterKeyline?: boolean }) => {
  const columns = footerColumns?.items ?? [];
  const firstFourColumns = columns.slice(0, 4);
  const fifthColumn = columns.slice(4)[0];
  return (
    <div className="content-wrapper" data-testid="site-footer">
      <div className={`keyline ${showFooterKeyline ? 'block' : 'hidden'}`}>
        <KeyLine />
      </div>
      <section
        className={`footer-section pb-8 sm:pb-12 flex flex-col sm:grid sm:grid-cols-5 gap-8 md:gap-16 sm:gap-12 justify-between ${showFooterKeyline ? 'pt-6 md:pt-12' : ''}`}
        data-testid="footer"
        {...liveUpdateAttrs(sys?.id, 'footerColumns')}>
        {columns.length > 0 &&
          firstFourColumns.map(({ heading, linksCollection }) => (
            <FooterColumn key={`footer-column-${heading}`} heading={heading} links={linksCollection?.items ?? []} />
          ))}

        {/* Combined grid column with links and social */}
        <div className="flex flex-col gap-6 w-full">
          {fifthColumn && (
            <FooterColumn
              key={`footer-column-${fifthColumn.heading}`}
              heading={fifthColumn.heading}
              links={fifthColumn.linksCollection?.items ?? []}
            />
          )}
          {showSocialLinkColumn && <FooterColumnSocial />}
        </div>
      </section>
    </div>
  );
};

export default SiteFooter;
